<template>
  <div class="gradient-color-pickers">
    <el-color-picker v-model="gradientColors[index-1]" v-for="index in 4" :key="index" @change="onChangeColor"></el-color-picker>
    <el-popover
    ref="popover"
    :visible-arrow="false"
    placement="left"
    width="300"
    trigger="click"
    popper-class="gradient-color-pickers-preset">
    <el-row :gutter="10" v-for="(index1) in (BackgroundOption.gradient.length / 2)" :key="index1" style="margin-bottom: 10px;">
      <el-col :span="12" v-for="(index2) in 2" :key="index2">
        <el-card :body-style="{ padding: '5px' }" shadow="hover">
          <div :style="gradientStyle(BackgroundOption.gradient[((index1-1) * 2) + (index2-1)])" class="preset" @click="onChangePreset(BackgroundOption.gradient[((index1-1) * 2) + (index2-1)])"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-button slot="reference">프리셋</el-button>
    </el-popover>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash';

import BackgroundOption from '@/views/dashboard/data/background-option';

export default {
  name: 'WGradientSettingForm',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      BackgroundOption,
      gradientColors: this.value,
    };
  },
  computed: {
    gradientStyle() {
      return (colors) => {
        if (!colors) {
          return {
          };
        }
        return {
          background: `linear-gradient(-45deg, ${colors.join(',')})`,
        };
      };
    },
  },
  watch: {
    value(val) {
      this.gradientColors = val;
    },
  },
  created() {
    if (isEmpty(this.gradientColors)) {
      this.initGradientColors();
    }
  },
  methods: {
    initGradientColors() {
      this.handleChange(cloneDeep(BackgroundOption.gradient[0]));
    },
    onChangePreset(colors) {
      if (colors) {
        this.handleChange(colors);
      }
      this.$refs.popover.showPopper = false;
    },
    onChangeColor() {
      this.handleChange(this.gradientColors);
    },
    handleChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style lang="scss">
.gradient-color-pickers {
  display: inline-block;
  width: 100%;
  .el-color-picker {
    margin-right: 5px;
    vertical-align: middle;
  }
  .el-button {
    float: right;
  }
}
.gradient-color-pickers-preset {
  .preset {
    cursor: pointer;
    width: 100%;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/form/GradientSettingForm.vue